import * as React from 'react';
import Loader from '../Loader';

const YoutubePlayer = () => {
    return (
        <div id="YoutubePlayer" className="Component__container">
            <Loader />
        </div>);
};

export default YoutubePlayer;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/YoutubePlayer/YoutubePlayer.tsx